import { style } from '@vanilla-extract/css';
import { themeVars } from '@tundr/theme';

export const iconButtonBaseClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  width: 48,
  height: 48,
});

export const iconClass = style({
  fontSize: themeVars.font.size.iconMd,
});
